export default __webpack_public_path__ + "static/DMSans-Latin-Ext-3ce027b1db7e53a2d39b61679055d987.woff2";